//import { EVENT_GET_URL } from "../../constants/service-constants";

export const SSE_CONFIG = {
    // EVENT_SOURCE_URL: EVENT_GET_URL,
    //EVENT_SOURCE_URL: 'http://localhost:5289/api/event/getEvents',
    // EVENT_SOURCE_URL: '/events',
    MAX_EVENTS: 40
  };